<template>
    <div class="component-group-list gap-lg col-span-12 flex flex-col">
        <div class="max-w-2xl rounded-md border border-gray-100 p-md">
            <CommentEditor
                :is-processing="commentEditorProcessing"
                placeholder="Write a comment…"
                submit-label="Submit"
                @submit="handleCommentEditorSubmit"
            >
                <template #footer-hint>
                    <p class="text-sm text-gray-400">Footer hint slot — surface-specific copy goes here.</p>
                </template>
            </CommentEditor>
        </div>

        <div v-if="lastCommentPayload" class="max-w-2xl">
            <span class="text-[11px] font-semibold uppercase tracking-[0.04em] text-gray-300">Last submitted payload:</span>
            <pre class="mt-xs overflow-auto rounded-md bg-gray-50 p-md text-xs text-dark-400">{{ lastCommentPayloadPreview }}</pre>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import CommentEditor from '@/components/incident/CommentEditor.vue';
import type { IncidentCommentPayload } from '@/lib/incident-comment-editor';

// Echo the last submitted payload and briefly toggle the processing spinner so the submit flow is
// observable without a backend.
const commentEditorProcessing = ref<boolean>(false);
const lastCommentPayload = ref<IncidentCommentPayload | null>(null);
const lastCommentPayloadPreview = computed(() => {
    if (!lastCommentPayload.value) return '';
    return JSON.stringify(
        {
            text: lastCommentPayload.value.text,
            attachments: lastCommentPayload.value.attachments.map((file) => ({ name: file.name, size: file.size, type: file.type })),
        },
        null,
        2,
    );
});

const handleCommentEditorSubmit = (payload: IncidentCommentPayload) => {
    lastCommentPayload.value = payload;
    commentEditorProcessing.value = true;
    window.setTimeout(() => {
        commentEditorProcessing.value = false;
    }, 600);
};
</script>
